export var ESessionKeys;
(function (ESessionKeys) {
    ESessionKeys["Member"] = "member";
    ESessionKeys["AccessToken"] = "accessToken";
    ESessionKeys["RefreshToken"] = "refreshToken";
    ESessionKeys["AccessTokenExpiration"] = "accessTokenExpiration";
    ESessionKeys["HertzLink"] = "sessionHertzLink";
    ESessionKeys["RemovedInvalidCdp"] = "removedInvalidCdp";
})(ESessionKeys || (ESessionKeys = {}));
